var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.114 157.43c-9.578 0-19.157 4.751-23.946 9.503l-210.723 209.060c-14.368 14.254-14.368 38.011 0 47.514 14.368 14.254 38.313 14.254 47.892 0l186.778-185.303 469.339 465.633c14.368 14.254 38.313 14.254 47.892 0 14.368-14.254 14.368-38.011 0-47.514l-493.284-489.39c-9.578-4.751-14.368-9.503-23.946-9.503v0 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck1);
export default __webpack_public_path__ + "static/media/check1.9b4d366ad3d2beaf4ba7e607eb0c1060.svg";
export { ForwardRef as ReactComponent };